import { useMap } from "@vis.gl/react-google-maps";
import { useMapDrawing } from "../../../hooks/useMapDrawing";

// Polygon drawing for zones. Replaces the removed drawing.DrawingManager with a
// custom click-to-draw engine; the onPolygonComplete contract is unchanged.
export const DrawingTools = ({ onPolygonComplete }) => {
  const map = useMap();

  useMapDrawing({
    map,
    type: "POLYGON",
    polygonOptions: {
      fillColor: "#1890ff",
      fillOpacity: 0.3,
      strokeColor: "#096dd9",
      strokeWeight: 2,
    },
    onComplete: ({ coordinates }) => {
      onPolygonComplete({ polygon: null, coordinates });
    },
  });

  return null;
};
